module.exports = __webpack_public_path__ + "img/eth.ddb2f041.png";